export default __webpack_public_path__ + "static/media/Reader's Bands of the Exiled.55ecbe43.jpg";